import { CSSObject } from "styled-components";

//App
import { vfxTheme } from "../VFX-UI/Theme/theme";

export const pageHeaderLabelStyles = (): CSSObject => {
  return {
    alignSelf: "center",
      color: vfxTheme.palette.blueGreys.bg500,
    fontFamily: "Montserrat",
    fontWeight: vfxTheme.fontWeights.semiBold,
    fontSize: `${vfxTheme.spaceUnits.sp01 * 4 + 4}px`,
    lineHeight: `${vfxTheme.spaceUnits.sp01 * 6 + 3}px`,
    marginBottom: `${vfxTheme.spaceUnits.sp02}px`
  };
};
